module.exports = __webpack_public_path__ + "img/ep-A-dosis.1547cc4a.jpg";